"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDemoAuth = exports.DemoAuthProvider = void 0;
var react_1 = __importDefault(require("react"));
var auth_mocks_1 = require("../../Metrics/auth-mocks");
var DEMO_AUTH_STORAGE_KEY = 'ws-ai-hub-demo-auth-user-id';
var findMockUserById = function (id) {
    if (!id) {
        return auth_mocks_1.mockCurrentUser;
    }
    var found = auth_mocks_1.mockUsers.find(function (user) { return user.id === id; });
    return found || auth_mocks_1.mockCurrentUser;
};
var noop = function () { return undefined; };
var DemoAuthContext = react_1.default.createContext({
    activeUser: auth_mocks_1.mockCurrentUser,
    availableUsers: auth_mocks_1.mockUsers,
    setActiveUserId: noop,
    resetActiveUser: noop,
});
exports.DemoAuthProvider = function (_a) {
    var children = _a.children;
    var _b = react_1.default.useState(function () {
        if (typeof window === 'undefined') {
            return auth_mocks_1.mockCurrentUser.id;
        }
        var storedId = window.localStorage.getItem(DEMO_AUTH_STORAGE_KEY);
        return findMockUserById(storedId).id;
    }), activeUserId = _b[0], setActiveUserIdState = _b[1];
    var activeUser = react_1.default.useMemo(function () { return findMockUserById(activeUserId); }, [activeUserId]);
    var setActiveUserId = react_1.default.useCallback(function (userId) {
        var nextUser = findMockUserById(userId);
        setActiveUserIdState(nextUser.id);
        if (typeof window !== 'undefined') {
            window.localStorage.setItem(DEMO_AUTH_STORAGE_KEY, nextUser.id);
        }
    }, []);
    var resetActiveUser = react_1.default.useCallback(function () {
        setActiveUserIdState(auth_mocks_1.mockCurrentUser.id);
        if (typeof window !== 'undefined') {
            window.localStorage.removeItem(DEMO_AUTH_STORAGE_KEY);
        }
    }, []);
    var value = react_1.default.useMemo(function () { return ({
        activeUser: activeUser,
        availableUsers: auth_mocks_1.mockUsers,
        setActiveUserId: setActiveUserId,
        resetActiveUser: resetActiveUser,
    }); }, [activeUser, resetActiveUser, setActiveUserId]);
    return react_1.default.createElement(DemoAuthContext.Provider, { value: value }, children);
};
exports.useDemoAuth = function () { return react_1.default.useContext(DemoAuthContext); };
